import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router";
import { useEnhancedBiApiClientProvider } from "../../contexts/ApiClientProviderContext";
import useDefineViewReportData from "../../hooks/useDefineViewReportData";
import { selectCurrentReport } from "../../store/selectors/currentReportSelectors";
import ApplyingDialog from "../common/dialogs/ApplyingDialog";
import ReportLoader from "../common/ReportLoader";
import DrillDownEntry from "./common/drillDown/DrillDownEntry";
import ViewCommonDataProvider from "./common/ViewCommonDataProvider";
import ReportNotFoundOrAccessForbidden from "./ReportNotFoundOrAccessForbidden";
import ViewReportPage from "./ViewReportPage";

const ViewRoot = () => {
  const { id } = useParams();
  const report = useSelector(selectCurrentReport);
  const { getReportsUrl, getEditReportUrl } = useEnhancedBiApiClientProvider();
  const { showReportNotFound, notFoundReason, isSwitchingReport, isFetching, runState, dispatchRunState } =
    useDefineViewReportData();

  if (id === undefined) {
    return <Navigate to={""} />;
  }

  if (showReportNotFound === true) {
    return <ReportNotFoundOrAccessForbidden getReportsUrl={getReportsUrl} reason={notFoundReason} />;
  }

  const isFetchingViewReport = !isSwitchingReport && isFetching;

  if (report === undefined || isFetchingViewReport) {
    return <ReportLoader text="Loading report..." />;
  }

  return (
    <ViewCommonDataProvider dispatchRunState={dispatchRunState} runState={runState}>
      <Grid container sx={{ bgcolor: "background.paper", width: "100%" }}>
        {isSwitchingReport && <ApplyingDialog open text="Loading report..." />}
        <ViewReportPage key={report.reportId} runState={runState} getEditReportUrl={getEditReportUrl} />
        <DrillDownEntry reportId={id} />
      </Grid>
    </ViewCommonDataProvider>
  );
};

export default ViewRoot;
